import { render, staticRenderFns } from "./BnA.vue?vue&type=template&id=3dd0135f&"
import script from "./BnA.vue?vue&type=script&lang=js&"
export * from "./BnA.vue?vue&type=script&lang=js&"
import style0 from "./BnA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports